export var PatternStatuses;
(function (PatternStatuses) {
    PatternStatuses["active"] = "ACTIVE";
    PatternStatuses["deleted"] = "DELETED";
})(PatternStatuses || (PatternStatuses = {}));
//# sourceMappingURL=patterns.js.map